module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delete_member_description":"Are you sure you want to delete {name}? Say good bye to {name} forever. Existing leads will be delegated to primary owner."},"id":{"delete_member_description":"Anda yakin ingin menghapus {name}? Ucapkan selamat tinggal pada {name} selamanya. Prospek yang ada akan didelegasikan ke pemilik utama."}}')
  delete Component.options._Ctor
}
